import { createContext, useContext } from 'react'

type ContentHeaderActions = {
  slot: HTMLElement | null
  attach: (node: HTMLElement | null) => void
}

export const ContentHeaderActionsContext = createContext<ContentHeaderActions | null>(null)

export const useContentHeaderActions = () => useContext(ContentHeaderActionsContext)
